import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-930462b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { class: "row row-cols-2 g-5 mb-4" }
const _hoisted_3 = { class: "row row-cols-2 g-5 mb-4" }
const _hoisted_4 = { class: "row row-cols-2 g-5 mb-4" }
const _hoisted_5 = { class: "row row-cols-2 g-5 mb-4" }
const _hoisted_6 = { class: "d-flex gap-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "row row-cols-2 g-5" }
const _hoisted_9 = { class: "row row-cols-2 g-5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "d-flex gap-1" }

import { ref, reactive } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import type { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventServices from "../../services/EventsServices";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import UploadImage from "../shop/UploadImage.vue";
import type { TabsPaneContext } from "element-plus";
import { AccessRoles, PointRoles } from "@/core/types/shop/ShopEventRoles";
import { Check } from "@element-plus/icons-vue";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditEvent',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {


const isSubmitting = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const langOptions = ref(LanguageTypes.all);
const langItem = ref<any>("");
const contentList = ref({});
const uploadImageRef = ref<any>(null);
const uploadMobileImageRef = ref<any>(null);
const ruleFormRef = ref<FormInstance>();
const detailRuleFormRef = ref<FormInstance>();
const contentPointRuleSwitch = ref(true);
const imageList = ref<any>([]);
const pointItem = ref("all");
const rules = reactive<any>({
  name: [
    { required: true, message: "Please input item name", trigger: "blur" },
  ],
  title: [
    { required: true, message: "Please input item title", trigger: "blur" },
  ],
  description: [
    {
      required: true,
      message: "Please input item description",
      trigger: "blur",
    },
  ],
});

const detailRules = reactive<any>({
  key: [{ required: true, message: "Please input key", trigger: "blur" }],
  accessRoles: [
    { required: true, message: "Please select access roles", trigger: "blur" },
  ],
  applyStartOn: [
    {
      required: true,
      message: "Please select apply start date",
      trigger: "blur",
    },
  ],
  applyEndOn: [
    {
      required: true,
      message: "Please select apply end date",
      trigger: "blur",
    },
  ],
  startOn: [
    {
      required: true,
      message: "Please select event start date",
      trigger: "blur",
    },
  ],
  endOn: [
    {
      required: true,
      message: "Please select event end date",
      trigger: "blur",
    },
  ],
});

const tab = ref(1);

const tabList = ref<any>([
  { label: "Content", value: 1 },
  { label: "Detail", value: 2 },
]);

const changeTab = (tab: TabsPaneContext, event: Event) => {
  tab.value = tab.props.name;
};

const accessRoles = AccessRoles;

const formData = ref<any>({});
const languageFormData = ref<any>({});

const show = async (_item: any) => {
  fetchData(_item.id);
  modalRef.value?.show();
};

const switchPointsContent = (lang: string) => {
  pointItem.value = lang;
};

const fetchData = async (id: number) => {
  isSubmitting.value = true;
  try {
    const res = await EventServices.queryEventById(id);
    formData.value = res;
    await fetchContent();
  } catch (error) {
    console.log(error);
  } finally {
    isSubmitting.value = false;
  }
};

const fetchContent = async () => {
  langItem.value = formData.value.languages[0].language;
  languageFormData.value = formData.value.languages[0];

  await fetchImage(languageFormData.value);
  const contents = formData.value.languages;
  for (let i = 0; i < contents.length; i++) {
    contentList.value[contents[i].language] = contents[i];
    languageExists(contents[i].language);
  }
};

const languageExists = (lang: string) => {
  let item = langOptions.value.find((item) => item.code == lang);
  if (item) {
    item.isAdded = true;
  }
};

const fetchImage = async (data: any) => {
  if (Object.keys(data.images).length > 0) {
    if (imageList.value[langItem.value]) {
      uploadImageRef.value.imageUrl =
        imageList.value[langItem.value]["desktop"];
      uploadMobileImageRef.value.imageUrl =
        imageList.value[langItem.value]["mobile"];
      return;
    }

    // Directly use the URL from images object
    if (data.images["desktop"]) {
      const imageUrl = data.images["desktop"];
      addImage(langItem.value, "desktop", imageUrl);
      uploadImageRef.value.imageUrl = imageUrl;
    }

    if (data.images["mobile"]) {
      const mobileImageUrl = data.images["mobile"];
      addImage(langItem.value, "mobile", mobileImageUrl);
      uploadMobileImageRef.value.imageUrl = mobileImageUrl;
    }
  } else {
    uploadImageRef.value.imageUrl = "";
    uploadMobileImageRef.value.imageUrl = "";
  }
};

const addImage = (lang: string, deviceType: string, imageUrl: string) => {
  if (!imageList.value[lang]) {
    imageList.value[lang] = {};
  }
  imageList.value[lang][deviceType] = imageUrl;
};

const switchLang = async (lang: string) => {
  if (langItem.value == lang) return;
  langItem.value = lang;
  const item = contentList.value[lang];
  if (item == null || item == undefined) {
    contentList.value[lang] = {
      name: "",
      title: "",
      description: "<p>description</p>",
      term: "<p>term</p>",
      images: {},
      instruction: {
        pointsRule: {
          all: "<p>all</p>",
          agent: "<p>agent</p>",
          sales: "<p>sales</p>",
          client: "<p>client</p>",
        },
      },
    };
    languageFormData.value = contentList.value[lang];
  } else {
    languageFormData.value = item;
  }
  await fetchImage(languageFormData.value);
};

const submit = async () => {
  isSubmitting.value = true;
  if (tab.value === 1) {
    await submitLanguage();
  } else {
    await submitDetail();
  }
  isSubmitting.value = false;
};

const submitLanguage = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;

  try {
    languageFormData.value.eventId = formData.value.eventId;
    languageFormData.value.name = languageFormData.value.title;

    await uploadMobileImageRef.value?.uploadImage().then(() => {
      if (uploadMobileImageRef.value?.imageUrls.length > 0) {
        languageFormData.value.images["mobile"] =
          uploadMobileImageRef.value?.imageUrls[0];
      }
    });

    await uploadImageRef.value
      ?.uploadImage()
      .then(() => {
        if (uploadImageRef.value?.imageUrls.length > 0) {
          languageFormData.value.images["desktop"] =
            uploadImageRef.value?.imageUrls[0];
        }
      })
      .then(() => {
        EventServices.updateEventLanguage(
          formData.value.id,
          langItem.value,
          languageFormData.value
        );
        MsgPrompt.success(langItem.value + " updated successfully");
        languageExists(langItem.value);
        emits("submit");
      });
  } catch (error) {
    console.log(error);
    MsgPrompt.error("Update failed");
    hide();
  }
};

const submitDetail = async () => {
  if (!detailRuleFormRef.value) return;

  let isValid = false;
  await detailRuleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;

  try {
    await EventServices.updateEvent(formData.value.id, formData.value);
    MsgPrompt.success("Event updated successfully");
  } catch (error) {
    console.log(error);
    MsgPrompt.error("Update failed");
  }
  emits("submit");
};

const hide = () => {
  modalRef.value?.hide();
  contentPointRuleSwitch.value = true;
  tab.value = 1;
  formData.value = {};
  languageFormData.value = {};
  contentList.value = {};
  imageList.value = {};
  uploadImageRef.value.imageUrl = "";
  uploadMobileImageRef.value.imageUrl = "";
  langItem.value = "";
  langOptions.value.forEach((item) => {
    item.isAdded = false;
  });
};

const uploadImg = async (file: any) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await EventServices.uploadImage(formData);
  return res["url"];
};

const modules = [
  {
    name: "imageUploader",
    module: ImageUploader,
    options: {
      upload: (file) => {
        return uploadImg(file);
      },
    },
  },
  {
    name: "blotFormatter",
    module: BlotFormatter,
  },
];

const getModules = (index: number) => {
  return [
    {
      name: "imageUploader" + index,
      module: ImageUploader,
      options: {
        upload: (file) => {
          return uploadImg(file);
        },
      },
    },
    {
      name: "blotFormatter" + index,
      module: BlotFormatter,
    },
  ];
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.editEvent'),
    "is-loading": isSubmitting.value,
    submit: submit,
    "before-close": hide,
    class: "w-1000px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
          type: "card",
          class: "demo-tabs",
          onTabClick: changeTab
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: index,
                label: item.label,
                name: item.value,
                disabled: isSubmitting.value
              }, null, 8, ["label", "name", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(_component_el_form, {
            ref_key: "detailRuleFormRef",
            ref: detailRuleFormRef,
            model: formData.value,
            rules: detailRules,
            "label-position": "top",
            class: "my-5"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.eventKey'),
                  prop: "key"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.key,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.key) = $event)),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.role'),
                  prop: "accessRoles"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: formData.value.accessRoles,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.accessRoles) = $event)),
                      disabled: isSubmitting.value
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (role, index) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: index,
                            label: role.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(role.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.site'),
                  prop: "accessSites"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: formData.value.accessSites,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.accessSites) = $event)),
                      disabled: isSubmitting.value
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (role, index) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: index,
                            label: role.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(role.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.applyStartDate'),
                  props: "applyStartOn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: formData.value.applyStartOn,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.applyStartOn) = $event)),
                      type: "datetime",
                      placeholder: _ctx.$t('fields.applyStartDate'),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.applyEndDate'),
                  props: "applyEndOn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: formData.value.applyEndOn,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.applyEndOn) = $event)),
                      type: "datetime",
                      placeholder: _ctx.$t('fields.applyEndDate'),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.eventStartDate'),
                  props: "startOn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: formData.value.startOn,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.startOn) = $event)),
                      type: "datetime",
                      placeholder: _ctx.$t('fields.eventStartDate'),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.eventEndDate'),
                  props: "endOn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: formData.value.endOn,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.endOn) = $event)),
                      type: "datetime",
                      placeholder: _ctx.$t('fields.eventEndDate'),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]), [
            [_vShow, tab.value == 2]
          ]),
          _withDirectives(_createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: languageFormData.value,
            rules: rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.language'),
                prop: "language"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: langItem.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((langItem).value = $event)),
                    disabled: isSubmitting.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: item.code,
                          label: item.code,
                          onClick: ($event: any) => (switchLang(item.code))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", null, _toDisplayString(item.code), 1),
                              (item.isAdded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Check))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.eventTitle'),
                  prop: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: languageFormData.value.title,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((languageFormData.value.title) = $event)),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('action.uploadDesktopImage')
                }, {
                  default: _withCtx(() => [
                    _createVNode(UploadImage, {
                      ref_key: "uploadImageRef",
                      ref: uploadImageRef
                    }, null, 512)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('action.uploadMobileImage')
                }, {
                  default: _withCtx(() => [
                    _createVNode(UploadImage, {
                      ref_key: "uploadMobileImageRef",
                      ref: uploadMobileImageRef
                    }, null, 512)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode(_component_el_radio_group, {
                modelValue: contentPointRuleSwitch.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((contentPointRuleSwitch).value = $event)),
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { label: true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.content")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { label: false }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.pointsRules")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (contentPointRuleSwitch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.content'),
                      prop: "description"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(QuillEditor), {
                            theme: "snow",
                            content: languageFormData.value.description,
                            "onUpdate:content": _cache[11] || (_cache[11] = ($event: any) => ((languageFormData.value.description) = $event)),
                            modules: getModules(2),
                            contentType: "html",
                            toolbar: "full",
                            enable: !isSubmitting.value
                          }, null, 8, ["content", "modules", "enable"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('title.termsAndConditions'),
                      prop: "term"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(QuillEditor), {
                            theme: "snow",
                            content: languageFormData.value.term,
                            "onUpdate:content": _cache[12] || (_cache[12] = ($event: any) => ((languageFormData.value.term) = $event)),
                            modules: getModules(1),
                            contentType: "html",
                            toolbar: "full",
                            enable: !isSubmitting.value
                          }, null, 8, ["content", "modules", "enable"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: pointItem.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((pointItem).value = $event)),
                      disabled: isSubmitting.value,
                      class: "mb-2"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PointRoles), (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_radio_button, {
                            key: index,
                            label: item.value,
                            onClick: ($event: any) => (switchPointsContent(item.value))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", null, _toDisplayString(item.label), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]),
                    _createVNode(_component_el_form_item, { prop: "description" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(QuillEditor), {
                            theme: "snow",
                            content: 
                    languageFormData.value.instruction.pointsRule[pointItem.value]
                  ,
                            "onUpdate:content": _cache[14] || (_cache[14] = ($event: any) => ((
                    languageFormData.value.instruction.pointsRule[pointItem.value]
                  ) = $event)),
                            modules: getModules(1),
                            contentType: "html",
                            toolbar: "full",
                            enable: !isSubmitting.value
                          }, null, 8, ["content", "modules", "enable"])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }, 8, ["model", "rules"]), [
            [_vShow, tab.value == 1]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})